export const formatterNum = (row, column, cellValue, index) => {
  return null != cellValue && '' != cellValue ? parseInt(cellValue).toLocaleString() : cellValue
}

/**
 * 숫자 → 자리 구분 글자 — 문장 안의 수(「고객 1,200명」)에 쓴다. 표 칸 포매터([formatterNum])와 같은 규칙이고, 값이 없으면 0 이다.
 * 의존성 없는 순수 함수라 단위 시험이 node 에서 그대로 읽는다.
 */
export const numberText = (value) => String(formatterNum(null, null, value == null ? 0 : value))
